import React, { forwardRef, useImperativeHandle, useContext, useEffect, useState, useRef, useMemo } from "react";
import { Popover, Modal, message, Divider, Input, TabsProps, Tabs, ConfigProvider, Button } from "antd";
import LOGO from "@/assets/images/logo.png";
// import PAY_COUNT from "@/assets/images/payCount.svg";
import PAY from "@/pages/Price/image/pay.png";
import AVATOR from "@/assets/images/avator.svg";
import { DataContext } from "@/context";
import IVITE_USER from "@/assets/images/header/invite_user.png";
import ACTIVATE_VIP from "@/assets/images/header/activate-vip-img.svg";
// import USER_VIP_BG from "@/assets/images/header/user_vip_bg.png";
import MessageIcon from "@/assets/images/header/系统通知 (1).svg";

import { debounce } from "lodash";
import { usePostHog } from 'posthog-js/react';
import { Dialog } from 'antd-mobile'

import Login from "./Login";
import Register from "./Register";
import ForgetPassword from "./ForgetPassword";
import NewYearImg from "@/assets/new_year_activity/矩形 53@2x.png";
import BannerImg from "@/assets/20260807/banner.png";

import eventBus from "@/event/event";
import { useLocation, useNavigate } from 'react-router-dom';
import { detectDevice } from '@/utils'
import {
  saveSixEight618ModalOnClose,
  shouldShowSixEight618Modal,
  SIX_EIGHT_618_PAID_EVENT,
} from '@/utils/sixEight618Modal';
import { List, Popup, Dropdown } from 'antd-mobile'
import { MenuUnfoldOutlined } from '@ant-design/icons';
// import { recordClickType } from "@/apis/record";
// import { clickTypeMapper } from '@/config/constent';
import dayjs from 'dayjs'

import "./styles.scss";
import { ComputeUsageModal } from "../ComputeUsageModal/ComputeUsageModal";
import { BuyComputeModal } from "../BuyComputeModal/BuyComputeModal";
import { postCode } from "@/apis/vip";
import ScrollLazyLoadImage from "@/components/ScrollLazyLoadImage";
import { recordEventRecord } from '@/apis/record';
import { type } from "os";
import { NewYearBtn } from "../NewYearBtn";
import { useActivityConfig } from "@/hooks/useActivityConfig";
import NewYearBtnIcon from "@/assets/new_year_activity/新春福利按钮.png";
import SIX_ONE_EIGHT from "@/assets/618/618.png";
import RecordScroll from "./recordScroll";
import XIE_ONE_EIGHT_TANCHUANG_IMG from "@/assets/618/618_tanchuang.png";
import TANCHUANG_IMG from "@/assets/20260807/tanchuang.png";

export const VipTypeImgMap = {
  'basic': '/header/vip_basic.png',
  'pro': '/header/vip_pro.png',
  'super': '/header/vip_super.png',
  'company': '/header/company.png',
}
export const VipTypeExpiredImgMap = {
  'basic': '/header/vip_basic-过期.png',
  'pro': '/header/vip_pro-过期.png',
  'super': '/header/vip_super-过期.png',
  'company': '/header/company.png',
}


interface Props {
  ref?: any;
  cssStyle?: React.CSSProperties;
  userOtherInfo: any;
  payCountObj: any;
}
const USER_VIP_BG = 'https://cemeta-resource-dev-1313090634.cos.ap-beijing.myqcloud.com/1/20250901141919181433/cca55482-ab80-42d8-90da-1906779bb2f1.png'
const BROARD_LINK = 'https://mi8elatzm1x.feishu.cn/wiki/OxyTw5WjqiqhgykN6bHcJZtxnRg?table=tblW4jUgv0eRYdSS&view=vewi8cd7P3'
const LESSON_LINK = 'https://mi8elatzm1x.feishu.cn/wiki/SfaxwB67JiEoHAkvpf1cVUfInVf?from=from_copylink'
const VIP_RENEW_QR_KF = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/1.png'
/** 会员到期前 72 小时内满足展示条件 */
const VIP_RENEW_EXPIRY_MS = 72 * 60 * 60 * 1000
/** 弹窗频率：自然日内最多展示 1 次 */
const VIP_RENEW_THRESHOLD_MS = 24 * 60 * 60 * 1000
const VIP_RENEW_MODAL_STORAGE_KEY = 'vipRenewModalData'

const isVipExpiringWithinThreshold = (vipExpiredAt?: string) => {
  if (!vipExpiredAt) {
    return false
  }
  const expiryTime = new Date(vipExpiredAt).getTime()
  if (Number.isNaN(expiryTime)) {
    return false
  }
  return expiryTime < Date.now() + VIP_RENEW_EXPIRY_MS
}

const hasVipRenewModalShownWithinDay = () => {
  try {
    const raw = localStorage.getItem(VIP_RENEW_MODAL_STORAGE_KEY)
    if (!raw) {
      return false
    }
    const { lastShown } = JSON.parse(raw)
    return Date.now() - (lastShown || 0) < VIP_RENEW_THRESHOLD_MS
  } catch {
    return false
  }
}

const markVipRenewModalShown = (vipExpiredAt?: string) => {
  localStorage.setItem(
    VIP_RENEW_MODAL_STORAGE_KEY,
    JSON.stringify({ lastShown: Date.now(), vipExpiredAt }),
  )
}

const shouldShowVipRenewModal = (vipExpiredAt?: string) => {
  return (
    isVipExpiringWithinThreshold(vipExpiredAt) &&
    !hasVipRenewModalShownWithinDay()
  )
}

const Header: React.FC<Props> = forwardRef((props: Props, ref: any) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { cssStyle = {}, userOtherInfo, payCountObj } = props;
  const {
    userInfo,
    mac_plugin_latest_url,
    win_plugin_latest_url,
    setContextValue
} = useContext(DataContext);
  const posthog = usePostHog();
  const { activityConfig } = useActivityConfig()
  const location = useLocation();
  const navigate = useNavigate();
  const macRef = useRef<HTMLAnchorElement | null>(null);
  const winRef = useRef<HTMLAnchorElement | null>(null);
  const [open, setOpen] = useState(false);
  // const [isLogin, setIsLogin] = useState(true);
  const [type, setType] = useState('login') // login register forgetpassword

  const [showPrice, setShowPrice] = useState(true);
  const [subscriptionOpen, setSubscriptionOpen] = useState(false)
  const [rightsRedemptionOpen, setRightsRedemptionOpen] = useState(false)
  const [rightsCode, setRightsCode] = useState('')
  const [announcementBar, setAnnouncementBar] = useState(false)

  // 消息
  const [messageOpen, setMessageOpen] = useState(false)

  const [buyComputeOpen, setBuyComputeOpen] = useState(false)
  const [computeUsageOpen, setComputeUsageOpen] = useState(false)

  const [tabKey, setTabKey] = useState('subscribe')

  const isPc = detectDevice()
  const [moreVisible, setMoreVisible] = useState(false)
  const [show618Modal, setShow618Modal] = useState(false)
  const [showVipRenewModal, setShowVipRenewModal] = useState(false)
  const headerRight = useRef(null)
  const headerLeft = useRef(null)

  const searchParamsString = window.location.href.split('?')[1] || '';
  const searchParams = new URLSearchParams(searchParamsString);
  const source = searchParams.get('s'); // source 参数值
  const detail = searchParams.get('d'); // detail 参数值

  const handleCloseAnnouncementBar = () => {
    const today = new Date().toDateString();
    localStorage.setItem('announcementBar', today);
    setAnnouncementBar(false);
  };

  const handleClose618Modal = () => {
    saveSixEight618ModalOnClose();
    setShow618Modal(false);
  };

  const is618PromotionEnabled = activityConfig?.vip_618_promotion?.use_config === true;

  useEffect(() => {
    if (!is618PromotionEnabled) {
      setShow618Modal(false);
      return;
    }
    if (location?.pathname !== '/price') {
      setShow618Modal(shouldShowSixEight618Modal());
    } else {
      setShow618Modal(false);
    }
  }, [location?.pathname, is618PromotionEnabled]);

  useEffect(() => {
    if (!is618PromotionEnabled) {
      return;
    }
    const onPaid = () => setShow618Modal(false);
    eventBus.on(SIX_EIGHT_618_PAID_EVENT, onPaid);
    return () => {
      eventBus.off(SIX_EIGHT_618_PAID_EVENT, onPaid);
    };
  }, [is618PromotionEnabled]);

  useEffect(() => {
    const vipExpiredAt = userOtherInfo?.vip_expired_at
    if (shouldShowVipRenewModal(vipExpiredAt)) {
      markVipRenewModalShown(vipExpiredAt)
      setShowVipRenewModal(true)
    } else {
      setShowVipRenewModal(false)
    }
  }, [userOtherInfo?.vip_expired_at])

  const tabsOnChange = (val: string) =>{
    setTabKey(val)
  }


  const openLogin = (s: string = 'login') => {
    handleShowLogin(s)
  }
  useImperativeHandle(ref, () => ({
    openLogin: openLogin,
  }));


  const handleShowLogin = (s: string) => {
    // setIsLogin(s);
    setType(s)
    setOpen(true);
  };

  const handleLogOut = () => {
    // recordClickType({
    //   event_name: clickTypeMapper.CEMETA_LOGOUT
    // }).catch((err) => {
    //   console.error('err', err)
    // })
    recordEventRecord({
      event_name: 'haohui_logout',
    })
    // posthog?.capture('haohui_logout', {
    //   type: 'pc',
    //   info: navigator?.userAgent
    // });
    searchParams.delete('y');
    searchParams.delete('openCredit');
    eventBus.emit('logout', searchParams.toString());
  }

  const handleJumpLink = (url: string, s: boolean = false) => {
    if (s && userOtherInfo?.vip_type === 'company') {
      messageApi.error('您已是企业会员，无法叠加个人会员权益')
      return 
    }
    searchParams.delete('y');
    searchParams.delete('openCredit');
    navigate({
      pathname: url, 
      search: '?' + searchParams.toString()
    });
  }

  const handleCloseVipRenewModal = () => {
    markVipRenewModalShown(userOtherInfo?.vip_expired_at)
    setShowVipRenewModal(false)
  }

  const handleVipRenewClick = () => {
    handleCloseVipRenewModal()
    handleJumpLink('/price')
  }

  const onOpenBuyCompute = () => {
    setBuyComputeOpen(true)
  }

  const onOpenComputeUsage = () => {
    setComputeUsageOpen(true)
  }
  const onCancelComputeUsage = () => {
    setComputeUsageOpen(false)
  }

  const onOpenSubscription = () => {
    setSubscriptionOpen(true)
  }
  const onCancelSubscription = () => {
    setSubscriptionOpen(false)
  }
  const onOpenRights = () => {
    setRightsRedemptionOpen(true)
  }
  const onCancelRights = () => {
    setRightsRedemptionOpen(false)
  }

  const exchange = async () => {
    if (!rightsCode.trim()) {
      message.warning('请输入权益码')
      return
    }
    try {
      await postCode({
        code: rightsCode
      }).then((res) => {
        setRightsCode('')
        if (Array.isArray(res?.msg_list) && res?.msg_list.length) {
              const renderContent = (array) => 
                  array.map((item, index) =>  <div key={index}>{item}</div>)
          message.success({ content: renderContent(res?.msg_list) || '兑换成功！', key: 'success', duration: 4 });
        } else {
          message.success("兑换成功")
        }
      })
    } catch (e) {
      message.error(e as any)
    }
  }
  
  const handleOpenCompute = debounce(() => {
    if (userInfo?.user_id === 0 || userInfo?.user_id) {
      onOpenBuyCompute()
    } else {
      openLogin(); // 触发子组件按钮点击
    }
  }, 300)

  const handleOpen3 = debounce(() => {
    if (userInfo?.user_id === 0 || userInfo?.user_id) {
      onOpenComputeUsage()
    } else {
      openLogin(); // 触发子组件按钮点击
    }
  }, 300)

  const handleOpenubscription = debounce(() => {
    if (userInfo?.user_id === 0 || userInfo?.user_id) {
      onOpenSubscription()
    } else {
      openLogin(); // 触发子组件按钮点击
    }
  }, 300)

  const handleOpenRights = debounce(() => {
    if (userInfo?.user_id === 0 || userInfo?.user_id) {
      onOpenRights()
    } else {
      openLogin(); // 触发子组件按钮点击
    }
  }, 300)

  useEffect(() => {
    const checkAnnouncementBar = () => {
      const today = new Date().toDateString();
      const lastSeen = localStorage.getItem('announcementBar');
      if (lastSeen !== today) {
        setAnnouncementBar(true);
      }
    };
    checkAnnouncementBar();
  }, [])

  useEffect(() => {
    if (location?.pathname === '/price') {
      setShowPrice(false)
    } else {
      setShowPrice(true)
    }
  }, [location?.pathname])

  useEffect(() => {
    if (location?.pathname === '/' ) {
      const queryParams = new URLSearchParams(location.search);
      if (queryParams?.get('y')) {
        setOpen(true);
        // setType('register')
        // setIsLogin(false);
      }
    }
  }, [location?.pathname, location.search])

  // console.log(location?.pathname)
  const renderInviteUser = () => {
    let start = '专属邀请码 '
    let end = '，限时免费'
    const shareCode = userOtherInfo?.invite_code
    let linkstring = shareCode
      ? window.location.origin + '/#/?y=' + shareCode
      : ''
      
    // let linkstring = userOtherInfo?.invite_code_desc || ''
    // const link = linkstring?.slice(linkstring.indexOf('http'))

    const handleCopy = async () => {
      try {
        const shareText = '森宇宙好绘AI PS插件\n先进AI设计功能+全球顶尖模型，免费体验!\n我的邀请码' + shareCode + '，点击链接注册→\n' + linkstring
        await navigator.clipboard.writeText(shareText);
        messageApi.open({
          type: 'success',
          content: '复制成功',
        });
        // console.log('复制成功');
        // 可选：提示用户
        // alert('已复制到剪贴板');
      } catch (err) {
        console.error('复制失败:', err);
        // 回退到老方法
        // fallbackCopy(text);
      }
    }
    return (
      <>
      {contextHolder}
      <div className="appHeader-invite-user">
        <div className="appHeader-invite-user-header">
          <span>邀请新用户</span>
        </div>
        <div className="appHeader-invite-user-body">
          <div className="appHeader-invite-user-body-text">
            <span>分享链接给新用户，当Ta通过链接成功注册后 
              <br /> 您可获得 <span className="appHeader-invite-text-number">100</span> 算力（被邀请人需完成一次生图任务）</span>        
          </div>
          <div className="appHeader-invite-user-body-link" style={{ cursor: 'pointer' }}>
            <div className="link-eclipse" style={{ color: '#717784', marginRight: '38px' }}>{linkstring}</div><span style={{ color: '#ffffff' }} onClick={handleCopy}>复制链接</span> 
          </div>
        </div>
        <div className="appHeader-invite-user-footer" onClick={() => handleJumpLink('/invite')}>
          <span>查看邀请列表</span>
        </div>
      </div>
      </>
    )
  }

  const handleOpenPopup = () => {
    setMoreVisible((state) => !state)
  }

  const MessageIconCom = ({ dot }: { dot?: boolean }) => {
    return <div className="message-icon">
      <img style={{ width: '20px', height: '20px' }} src={MessageIcon} alt="MessageIcon" />
      {dot && <div className="message-dot"></div>}
    </div>
  }

  const renderMyVipType = () => {
    if (!userOtherInfo?.vip_type) {
      {/* 未开通 */}
      return (
        <div className="subscribe-not-activated">
          <div className="subscribe-not-activated-desc">
            你还没有开通会员哦
          </div>
          <div className="subscribe-not-activated-button" onClick={() => handleJumpLink('/price')}>
            查看会员套餐
          </div>
        </div>
      )
    }
    if (new Date(userOtherInfo?.vip_expired_at) < new Date()) {
      {/* 过期 */}
      return (
        <div className="subscribe-expired">
          <div className="subscribe-expired-left">
            <img style={{ width: '64px', height: 'auto' }} src={VipTypeExpiredImgMap[userOtherInfo?.ext?.last_vip_type]}/> // 已过期
          </div>

          <div className="subscribe-expired-right">
            <div className="subscribe-expired-text">
              已过期时间
            </div>
            <div className="subscribe-expired-time">
              {dayjs(userOtherInfo?.vip_expired_at).format("YYYY-MM-DD-HH:mm")}
            </div>
          </div>
        </div>
      )
    }

    {/* 有效 */}
    return (
      <div className="subscribe-effective">
        <div className="subscribe-effective-left">
           <img style={{ width: '64px', height: 'auto' }} src={VipTypeImgMap[userOtherInfo?.vip_type]}/>
        </div>
        <div className="subscribe-effective-right">
          <div className="subscribe-effective-text">
            到期时间
          </div>
          <div className="subscribe-effective-time">
            {dayjs(userOtherInfo?.vip_expired_at).format("YYYY-MM-DD-HH:mm")}
          </div>
        </div>
      </div>
    )
  }


  const items: TabsProps['items'] = [
    {
      key: 'subscribe',
      label: '订阅计划管理',
      children: <div className="subscribe-container">
        <div className="subscribe-title">
          我的会员
        </div>
        <div className="subscribe-content">
          {renderMyVipType()}
        </div>
      </div>
    },
    {
      key: 'record',
      label: '购买记录',
      children: <RecordScroll userInfo={userOtherInfo} />,
      // children: <div className="record-container">
      //   {/* 这里做一个滚动加载5条数据 */}
      //   {/* <div className="record-list">
      //     <div className="record-item">
      //       <div className="record-item-head">
      //         <div className="record-item-icon">
      //         </div>
      //         <div className="record-item-name">
      //           专业会员
      //         </div>
      //       </div>
      //       <div className="record-item-desc">
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             订阅类型
      //           </div>
      //           <div className="desc-item-right">
      //             单月购买
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             价格
      //           </div>
      //           <div className="desc-item-right">
      //             {123}元
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             购买时间
      //           </div>
      //           <div className="desc-item-right">
      //             {dayjs("2025-11-31 18:00").format("YYYY-MM-DD-HH:mm")}
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             订单编号
      //           </div>
      //           <div className="desc-item-right">
      //             AJDJ_djjss-134435
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             支付方式
      //           </div>
      //           <div className="desc-item-right">
      //             微信支付-134435
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //     <div className="record-item">
      //       <div className="record-item-head">
      //         <div className="record-item-icon">
      //         </div>
      //         <div className="record-item-name">
      //           专业会员
      //         </div>
      //       </div>
      //       <div className="record-item-desc">
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             订阅类型
      //           </div>
      //           <div className="desc-item-right">
      //             单月购买
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             价格
      //           </div>
      //           <div className="desc-item-right">
      //             {123}元
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             购买时间
      //           </div>
      //           <div className="desc-item-right">
      //             {dayjs("2025-11-31 18:00").format("YYYY-MM-DD-HH:mm")}
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             订单编号
      //           </div>
      //           <div className="desc-item-right">
      //             AJDJ_djjss-134435
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             支付方式
      //           </div>
      //           <div className="desc-item-right">
      //             微信支付-134435
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //     <div className="record-item">
      //       <div className="record-item-head">
      //         <div className="record-item-icon">
      //         </div>
      //         <div className="record-item-name">
      //           专业会员
      //         </div>
      //       </div>
      //       <div className="record-item-desc">
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             订阅类型
      //           </div>
      //           <div className="desc-item-right">
      //             单月购买
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             价格
      //           </div>
      //           <div className="desc-item-right">
      //             {123}元
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             购买时间
      //           </div>
      //           <div className="desc-item-right">
      //             {dayjs("2025-11-31 18:00").format("YYYY-MM-DD-HH:mm")}
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             订单编号
      //           </div>
      //           <div className="desc-item-right">
      //             AJDJ_djjss-134435
      //           </div>
      //         </div>
      //         <div className="desc-item">
      //           <div className="desc-item-left">
      //             支付方式
      //           </div>
      //           <div className="desc-item-right">
      //             微信支付-134435
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   </div> */}
      // </div>
    }
  ];

  const handleOpenModel = (type: 'free' | 'old' | 'version') => {
    setMessageOpen(true)
    localStorage.setItem('messageRead', 'true')
  }

  const messageTabsItem: TabsProps['items'] = [
    {
      key: 'message',
      label: '系统消息',
      children: <div className="message-tab">
        <div className="message-list">
          <div className="message-list-item" onClick={() => handleOpenModel('free')}>
            <div className="message-list-item-left">
              <div className="message-list-item-icon">
                <MessageIconCom/>
              </div>
              <div className="message-list-item-desc">
                <div className="list-item-desc-title">
                  {"「通知」正式付费版上线！"}
                </div>
                <div className="list-item-desc-text">
                  点击查看详情
                </div>
              </div>
            </div>
            <div className="message-list-item-right">
              <div className="message-list-item-date">
                2025年12月15日
              </div>
            </div>
          </div>
          {/* <div className="message-list-item" onClick={() => handleOpenModel('old')}>
            <div className="message-list-item-left">
              <div className="message-list-item-icon">
                <MessageIconCom />
              </div>
              <div className="message-list-item-desc">
                <div className="list-item-desc-title">
                  【{"老用户专享福利"}】
                </div>
                <div className="list-item-desc-text">
                  点击查看详情
                </div>
              </div>
            </div>
            <div className="message-list-item-right">
              <div className="message-list-item-date">
                2025年11月7日
              </div>
            </div>
          </div>
          <div className="message-list-item" onClick={() => handleOpenModel('version')}>
            <div className="message-list-item-left">
              <div className="message-list-item-icon">
                <MessageIconCom/>
              </div>
              <div className="message-list-item-desc">
                <div className="list-item-desc-title">
                  【{"V1.3.2版本更新"}】
                </div>
                <div className="list-item-desc-text">
                  点击查看详情
                </div>
              </div>
            </div>
            <div className="message-list-item-right">
              <div className="message-list-item-date">
                2025年11月7日
              </div>
            </div>
          </div> */}
        </div>
      </div>
    }
  ]
  

  const renderActivateVip = () => {
    searchParams.delete('y');
    searchParams.delete('openCredit');
    return (
      <>
        <div className="appHeader-activate-vip">
          <div className="appHeader-activate-vip-title">
            <span>开通专业会员，可承接设计商单</span>
          </div>
          <div className="appHeader-activate-vip-desc">
            <div>
              ·每月 3000 + 企业商单
            </div>
             <div>
              ·客单价≥800 元
            </div>
             <div>
              ·免佣金
            </div>
             <div>
              ·提现秒到账
            </div>
          </div>
          <div className="appHeader-activate-vip-footer" onClick={() => handleJumpLink('/price')}>
            <div className="activate-vip-footer-button">
              <span>开通会员</span>
            </div>
          </div>
        </div>
      </>
    )
  }

  const donwloadContent = () => {
    const handleMACDownload = debounce(() => {
      if (!isPc) {
        Dialog.alert({
          content: '请在电脑端打开！',
          onConfirm: () => {
            console.log('Confirmed')
          },
        })
        return
      }
      if (macRef.current) {
        macRef.current?.click();
        if (source && detail) {
          recordEventRecord({
            event_name: 'haohui_source_download',
            source: source,
            event_id: detail,
            tag: {
              type: 'mac',
            }
          })
          // posthog?.capture('haohui_source_download', {
          //   source: source,
          //   detail: detail,
          //   type: 'mac'
          // });
        }
        // posthog?.capture('haohui_download', {
        //   type: 'mac',
        //   info: navigator?.userAgent
        // });
        recordEventRecord({
          event_name: 'haohui_download',
          tag: {
            type: 'mac',
          }
        })
      }
    }, 1000);

    const handleWINDownload = debounce(() => {
      if (!isPc) {
        Dialog.alert({
          content: '请在电脑端打开！',
          onConfirm: () => {
            console.log('Confirmed')
          },
        })
        return
      }
      if (winRef.current) {
        winRef.current?.click();
        if (source && detail) {
          recordEventRecord({
            event_name: 'haohui_source_download',
            source: source,
            event_id: detail,
            tag: {
              type: 'win',
            }
          })
          // posthog?.capture('haohui_source_download', {
          //   source: source,
          //   detail: detail,
          //   type: 'win'
          // });
        }
        recordEventRecord({
          event_name: 'haohui_download',
          tag: {
            type: 'win',
          }
        })
        // posthog?.capture('haohui_download', {
        //   type: 'win',
        //   info: navigator?.userAgent
        // });
      }
    }, 1000);
    return (
      <div className="header-action-download">
        <div className="action-download-container">
          <div className="action-download-item" onClick={handleMACDownload}>
            <span>
              mac 版本下载
            </span>
          </div>
          <div className="action-download-item" onClick={handleWINDownload}>
            <span>
              win 版本下载
            </span>
          </div>
        </div>
        <a
          ref={macRef}
          href={mac_plugin_latest_url}
          style={{ visibility: "hidden" }}
        >
          {" "}
        </a>
        <a
          ref={winRef}
          href={win_plugin_latest_url}
          style={{ visibility: "hidden" }}
        >
          {" "}
        </a>
      </div>
  )};
  const computerPowerContent = () => {
    return (
      <div className="action-computer-container">
        <div className="action-computer-item" onClick={handleOpenCompute}>
          <span>
            购买算力
          </span>
        </div>
        {/* 12.1上线 暂时隐藏 */}
        {/* <div className="action-computer-item" onClick={handleOpen3}>
          <span>
            算力消耗明细
          </span>
        </div> */}
      </div>
  )};

  const messageContent = () => {
    const operations = <div className="message-tabs-operation" onClick={() => localStorage.setItem('messageRead', 'true')}>
      全部标记为已读
    </div>
    // const operations = null
    return (
      <div className="message-content-container">
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemHoverColor: "#fff",
                itemSelectedColor: "#fff",
                inkBarColor: "#fff",
                itemColor:"#9c9c9c",
              },
            },
          }}
        >
           {/* 只有一个选项，暂时写死 */}
           {/* ant-tabs-nav */}
          <Tabs className="message-tabs" tabBarExtraContent={operations} activeKey={'message'} items={messageTabsItem} onChange={tabsOnChange} />
        </ConfigProvider>
      </div>
  )};
  const userInfoContent = () => {
    return (
      <div className="user-info-container">
        <div className="user-card">
          <div className="user-card-avatar">
            <img style={{ width: '48px', height: '48px' }} src={userOtherInfo?.avatar || AVATOR} alt="avator" />
          </div>
          <div className="user-card-info">
            <div className="user-card-info-title">
              <div className="user-name">
                {userOtherInfo?.name || "立即登录"}
              </div>
              <div>
                {userOtherInfo?.vip_expired_at
                  ? new Date(userOtherInfo?.vip_expired_at) < new Date() 
                    ? <img className="h-[18px] ml-1 mt-[2px]" src={VipTypeExpiredImgMap[userOtherInfo?.ext?.last_vip_type]}/> // 已过期
                    : <img className="h-[18px] ml-1 mt-[2px]" src={VipTypeImgMap[userOtherInfo?.vip_type]}/> // 未过期
                  : <div></div>}
              </div>
            </div>
            <div className="user-card-info-expired">
              {userOtherInfo?.vip_expired_at 
                ? new Date(userOtherInfo?.vip_expired_at) < new Date()
                  ? `会员已过期${Math.floor((new Date().getTime() - new Date(userOtherInfo?.vip_expired_at).getTime()) / (1000 * 60 * 60 * 24))}天`
                  : "会员有效期: " + dayjs(userOtherInfo.vip_expired_at).format("YYYY-MM-DD")
                : "未开通会员"}
            </div>
          </div>
        </div>
        <div className="user-vip-box">
          <img className="user-vip-bg" src={USER_VIP_BG} />
          {/* <div className="user-vip-desc">
            <div><span className="vip-desc-dot">·</span>尊享智能扩图</div>
            <div><span className="vip-desc-dot">·</span>高清修复等会员功能</div>
          </div> */}
          <div className="user-vip-renew" onClick={() => handleJumpLink('/price')}>
            {userOtherInfo?.vip_expired_at ? '续费延长' : '开通VIP'}
          </div>
        </div>
        <div className="user-info-action">
          <div className="user-info-action-item" onClick={handleOpenubscription}>
            <span>订阅管理</span>
          </div>
          <div className="user-info-action-item" onClick={handleOpenRights}>
            <span>权益兑换</span>
          </div>
        </div>
        <div className="user-info-footer" onClick={handleLogOut}>
          <div className="logout-button">
            退出登录
          </div>
        </div>
      </div>
    )
  };

  // const handlePrice = () => {
  //   searchParams.delete('y');
  //   searchParams.append('openCredit', 'true');
  //   navigate({ pathname: '/price', search: '?' + searchParams.toString() })
  // }
  return (
    <>
    {contextHolder}
    <Modal
      open={show618Modal && is618PromotionEnabled}
      onCancel={handleClose618Modal}
      footer={null}
      closable={false}
      centered
      maskClosable
      className="benefit-modal six-eight-benefit-modal"
      width="auto"
      zIndex={200}
      styles={{
        content: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          padding: 0,
        },
      }}
    >
      {/* 618限时专享 */}
      <div className="six-eight-benefit-modal__content">
        <img
          className="six-eight-benefit-modal__img"
          src={TANCHUANG_IMG}
          alt="8月福利"
          onClick={() => handleJumpLink('/price')}
        />
        <button
          type="button"
          className="six-eight-benefit-modal__close"
          onClick={handleClose618Modal}
        >
          放弃福利 <span>×</span>
        </button>
      </div>
    </Modal>
    <Modal
      open={showVipRenewModal}
      onCancel={handleCloseVipRenewModal}
      footer={null}
      closable={false}
      centered={false}
      mask={false}
      maskClosable={false}
      width={420}
      zIndex={150}
      wrapClassName="vip-renew-modal-wrap"
      className="vip-renew-modal"
    >
      <button
        type="button"
        className="vip-renew-modal__close"
        onClick={handleCloseVipRenewModal}
        aria-label="关闭"
      >
        ×
      </button>
      <div className="vip-renew-modal__body">
        <p className="vip-renew-modal__title">您的会员剩余不足</p>
        <p className="vip-renew-modal__action">
          请
          <span className="vip-renew-modal__link" onClick={handleVipRenewClick}>
            续费
          </span>
        </p>
        <p className="vip-renew-modal__hint">联系客服获取续费优惠</p>
        <img
          className="vip-renew-modal__qrcode"
          src={VIP_RENEW_QR_KF}
          alt="联系客服二维码"
        />
      </div>
    </Modal>
    <div className={isPc ? 'app-header' : 'mobile-app-header'} style={cssStyle} >
      {(activityConfig?.vip_618_promotion?.use_config && announcementBar && isPc) && <div className="w-full relative">
        <img className="h-[39px] w-full" src={BannerImg} alt="new-year" />
        <div className="absolute inset-0 flex items-center justify-between px-4">
          <div>&nbsp;</div>
          <div className="flex gap-8 items-center">
            <div className="text-[14px] font-bold text-white flex-1 text-center" style={{ color: 'darkblue'}}>
              {/* {`【免费送3个月会员】新春限时福利！${dayjs(activityConfig?.vip_new_year_promotion?.start_at).format("YYYY年M月D日")}-${dayjs(activityConfig?.vip_new_year_promotion?.expired_at?.substring(0, 10)).format("M月D日")}，买 1 年会员免费多赠送 3个月会员！`} */}
              {/* <span className="font-normal">618限时专享，</span>买 1 年会员免费多赠送2个月会员！买季卡最高赠3600算力！ */}
              8月年卡福利，买 1 年会员免费多赠送2个月会员！
            </div>
            <NewYearBtn className="mr-4" onClick={() => handleJumpLink('/price')}>
              <div className="text-sm font-bold px-6 py-1" onClick={() => handleJumpLink('/price')}>
                立享福利
              </div>
            </NewYearBtn>
          </div>
          <div className="cursor-pointer text-white" onClick={handleCloseAnnouncementBar}>
            × 放弃福利 
          </div>
        </div>
      </div>}
      <div className={(isPc ? 'px-12 h-[81px]' : 'px-4 h-[61px]') + " box-border flex justify-between w-full "}>
      {
        isPc
          ? (
            <>
            <div className="header-left" ref={headerLeft}>
              <div className="cemeta-logo" onClick={() => handleJumpLink('/')}>
                <img src={LOGO} alt="logo" />
              </div>
              {/* <div className="divider"></div> */}
              <div className="title-container">
              {/* <div className="meta-title">森宇宙好绘</div> */}
              <div className="header-action">
                <div className="header-action-item" onClick={() => handleJumpLink('/')}>
                  <span>首页</span>
                </div>
                {/* 目前无法实现,暂时隐藏 */}
                {/* <div className="header-action-item" onClick={() => navigate({ pathname: '/commercial-order', search: '?' + searchParams.toString() })}>
                  <span>设计商单平台</span>
                </div> */}
                <div className="header-action-item">
                  <a href={BROARD_LINK} target="_blank">案例广场</a>
                </div>
                <div className="header-action-item" >
                  <a href={LESSON_LINK} target="_blank">使用教程</a>
                </div>
                <div className="header-action-item" onClick={() => handleJumpLink('/price')}>
                  <span>价格</span>
                </div>
                <div className="header-action-item">
                  <Popover 
                    content={donwloadContent}  
                    placement="bottomRight"
                    color="#2B303B"
                    arrow={false}
                  >
                     <span>下载</span>
                  </Popover>
                </div>
              </div>
            </div>
            </div>
            <div className="header-right" ref={headerRight}>
              {
                userInfo?.user_id === 0 || userInfo?.user_id
                  ? (
                    <>
                    {/* <img className="new-year-btn-img" src={NewYearBtnIcon} alt="新春福利按钮.png" /> */}
                      {/* {(activityConfig?.vip_618_promotion?.use_config) && <div className="header-new-year-btn" onClick={() => handleJumpLink('/price')}>
                        
                        <img className="new-year-btn-img" src={SIX_ONE_EIGHT} alt="618福利按钮.png" />
                      </div>} */}
                      
                      {/* 12.1上线 暂时隐藏 */}
                      {/* <div className="header-activate-vip"  style={{ marginRight: '8px' }}>
                        <Popover
                          getPopupContainer={(trigger: any) => trigger.parentElement}
                          content={renderActivateVip()}
                          placement="bottomRight"
                          color="#2B303B"
                          arrow={false}
                        >
                          <img className="activate-vip-img" src={ACTIVATE_VIP} alt="activate vip" />
                        </Popover>
                      </div> */}
                      {
                        userOtherInfo?.invite_code 
                          ? (
                            <div className="header-invite" style={{ marginRight: '8px' }}>
                              <Popover
                                getPopupContainer={(trigger: any) => trigger.parentElement}
                                content={renderInviteUser()}
                                placement="bottomRight"
                                color="#2B303B"
                                arrow={false}
                              >
                                <img className="invite-img" src={IVITE_USER} alt="invite user" />
                              </Popover>
                            </div>
                          )
                          : null
                      }
                      
                      <div className="user-info">
                        <Popover
                            getPopupContainer={(trigger: any) => trigger.parentElement}
                            content={computerPowerContent}
                            placement="bottomRight"
                            color="#2B303B"
                            arrow={false}
                          >
                          <div className="coin-info">
                            <div className="coin-icon">
                              <img style={{ width: '20px', height: '20px' }} src={PAY} alt="paycount" />
                            </div>
                            <span className="coin-count">{payCountObj?.recharge?.pay + payCountObj?.subscribe?.pay + payCountObj?.gift?.pay + payCountObj?.old?.pay}算力</span>
                            <span style={{ marginLeft: '8px', color: '#446af6'}} onClick={() => handleJumpLink('/price', true)}>充值</span>
                          </div>
                        </Popover>
                        {/* v1.3.2 版本需要放开,文本写死 */}
                        <Popover
                          getPopupContainer={(trigger: any) => trigger.parentElement}
                          content={messageContent}
                          placement="bottomRight"
                          color="#2B303B"
                          arrow={false}
                        >
                          <div className="header-message">
                            <MessageIconCom dot={localStorage.getItem('messageRead') !== 'true'}/>
                          </div>
                        </Popover>
                        
                        <Popover
                          content={userInfoContent}
                          placement="bottomRight"
                          arrow={false}
                          color="#2B303B"
                        >
                          <img style={{ width: '48px', height: '48px' }} src={userOtherInfo?.avatar || AVATOR} alt="avator" />
                        </Popover>
                      </div> 
                    </>
                  )
                  : (
                    <>
                      {/* <div className="sign-up" style={{ marginRight: '8px' }} onClick={() => handleShowLogin('register')}>
                        <span>注册</span>
                      </div> */}
                      <div className="sign-in" onClick={() => handleShowLogin('login')}>
                        <span>注册/登录</span>
                      </div>
                    </>
                  )
              }
            </div>
            </>
          )
          : (
            <>
              <div className="header-left">
                <div className="cemeta-logo" onClick={() => handleJumpLink('/')}>
                  <img style={isPc ? {} : { width: '141px', height: 'auto' }} src={LOGO} alt="logo"  />
                </div>
                {/* <div className="divider"></div>
                <div className="mobile-title-container">
                  <div className="mobile-meta-title">森宇宙好绘</div>
                </div> */}
              </div>
              <div className="header-right" onClick={handleOpenPopup}>
                <MenuUnfoldOutlined style={{ fontSize: '1.5em' }} />
                <Popup
                  position='top'
                  visible={moreVisible}
                  onMaskClick={() => {
                    setMoreVisible(false)
                  }}
                  bodyStyle={{ backgroundColor: 'transparent', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                  <div className="header-right-dropdown">
                    {/* 把onclick事件加上 */}
                    <div style={{display: 'flex', flexDirection: 'column', marginTop: '60px' }}>
                      {
                        location?.pathname !== '/'
                          ? <div className="header-right-dropdown-item" onClick={() => handleJumpLink('/')}>首页</div>
                          : null
                      }
                      <div className="header-right-dropdown-item" onClick={() => {handleJumpLink('/price');setMoreVisible(false)}}>
                        价格
                      </div>
                    </div>
                    
                    <div className="header-right-dropdown-item" onClick={() => { window.open(LESSON_LINK); setMoreVisible(false) }}>
                      使用教程
                    </div>
                    <div className="header-right-dropdown-item" onClick={() => { window.open(BROARD_LINK); setMoreVisible(false) }}>
                      案例广场
                    </div>
                    {
                      userInfo?.user_id === 0 || userInfo?.user_id
                        ? (
                          <>
                            {
                              location?.pathname !== '/invite'
                                ? (
                                  <div className="header-right-dropdown-item" onClick={() => { handleJumpLink('/invite'); setMoreVisible(false) }}>
                                    邀请好友
                                  </div>
                                )
                                : null
                            }
                            <div className="header-right-dropdown-item" onClick={() => { handleLogOut(); setMoreVisible(false) }}>
                              退出登录
                            </div>
                          </>
                        )
                        : (
                          <>
                            <div className="header-right-dropdown-item" onClick={() =>{ handleShowLogin('login'); setMoreVisible(false)}}>
                              注册/登录
                            </div>
                            {/* <div className="header-right-dropdown-item" onClick={() => {handleShowLogin('register'); setMoreVisible(false)}}>
                              注册
                            </div> */}
                          </>
                        )
                    }  
                    {/* <List.Item prefix={<img style={{ width: '24px', height: '24px' }} src={LOGO} alt="logo" />} onClick={() => { navigate('/'); setMoreVisible(false) }}>
                      首页
                    </List.Item>
                    <List.Item prefix={<i className="ri-price-tag-3-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { navigate('/price'); setMoreVisible(false) }}>
                      价格
                    </List.Item>
                    <List.Item prefix={<i className="ri-book-2-fill" style={{ fontSize: '24px' }}></i> } onClick={() => { window.open(LESSON_LINK); setMoreVisible(false) }}>
                      使用教程
                    </List.Item>
                    <List.Item prefix={<i className="ri-gallery-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { window.open(BROARD_LINK); setMoreVisible(false) }}>
                      案例广场
                    </List.Item>
                    {
                      userInfo?.user_id
                        ? (
                          <>
                            {
                              location?.pathname !== '/invite'
                                ? (
                                  <List.Item prefix={<i className="ri-user-add-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { navigate('/invite'); setMoreVisible(false) }}>
                                    邀请好友
                                  </List.Item>
                                )
                                : null
                            }
                            <List.Item prefix={<i className="ri-logout-box-r-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { handleLogOut(); setMoreVisible(false) }}>
                              退出登录
                            </List.Item>
                          </>
                        )
                        : (
                          <>
                            <List.Item prefix={<i className="ri-user-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { handleShowLogin(true); setMoreVisible(false) }}>
                              登录
                            </List.Item>
                            <List.Item prefix={<i className="ri-user-smile-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { handleShowLogin(false); setMoreVisible(false) }}>
                              注册
                            </List.Item>
                          </>
                        )
                    } */}
                  </div>
                </Popup>
              </div>
            </>
            
          )
      }
      </div>
    </div>
      <Modal
        className="header-model"
        width={'430px'}
        title={null}
        footer={null}
        open={open}
        maskClosable={false}
        onCancel={() => {
          setOpen(false);
        }}
        destroyOnHidden
      >
        {
          type === 'login' 
            ? <Login open={open} propsSetOpen={(value: boolean) => setOpen(value)} propsSetIsLogin={(value: string) => setType(value)} /> 
            : type === 'register' 
                ? <Register propsSetIsLogin={(value: string) => setType(value)} />
                : <ForgetPassword open={open} propsSetOpen={(value: boolean) => setOpen(value)} propsSetIsLogin={(value: string) => setType(value)} /> 
        }
      </Modal>
      {/* 兑换权益弹框 */}
      <Modal 
        className="rights-redemption-modal"
        width={'380px'}
        title={null}
        footer={null}
        open={rightsRedemptionOpen}
        maskClosable={false}
        onCancel={onCancelRights}
      >
        <div className="rights-redemption-title">
          <span>权益兑换</span>
        </div>
        <div className="rights-user-info">
          <div className="rights-user-info-avatar">
            <img src={userOtherInfo?.avatar || AVATOR} alt="avator" />
          </div>
          <div className="rights-user-info-name"> 
            {userOtherInfo?.name}
          </div>
        </div>
        <div className="rights-redemption-body">
          <Input className="rights-redemption-input" placeholder="请输入兑换码，区分大小写" value={rightsCode} onChange={(e)=>{setRightsCode(e.currentTarget.value)}}/>
          <div className="rights-redemption-button" onClick={exchange}>
            立即兑换
          </div>
        </div>
        <div className="rights-redemption-footer">
          <div className="rights-redemption-desc">
            兑换须知<br />
            <br />
            1.一个兑换码仅能兑换一次，请谨慎兑换;<br />
            2.兑换码存在有效期，过期无法兑换，请尽快使用；一般有效期为一年，<br />
            具体以兑换码发放方的信息为准;<br />
            3.兑换码需登录后才可兑换，请先登录再兑换;<br />
            4.会员&积分权益有效时间与兑换时长一致；兑换会员赠送的积分值<br />
            以兑换天数进行折算;<br />
            5.本内容为虚拟产品，兑换后不可退款；<br />
            6.兑换过程中如遇到问题，请微信联系CeMeta小助手，专属客服将会处理;<br />
            7.兑换权益流程最终解释，归森宇宙好绘所有。<br />
          </div>
        </div>
      </Modal>
      <Modal 
        className="subscription-modal"
        // width={'380px'}
        title={null}
        footer={null}
        open={subscriptionOpen}
        maskClosable={false}
        onCancel={onCancelSubscription}
      >
        <div>
          <div className="subscription-title">
            订阅管理
          </div>
          <div>
            <ConfigProvider
              theme={{
                components: {
                  Tabs: {
                    itemHoverColor: "#fff",
                    itemSelectedColor: "#fff",
                    inkBarColor: "#fff",
                    itemColor:"#9c9c9c",
                  },
                },
              }}
            >
              <Tabs className="subscription-tabs" activeKey={tabKey} items={items} onChange={tabsOnChange} />
            </ConfigProvider>
          </div>
        </div>
      </Modal>
      {/* 购买算力 */}
      <BuyComputeModal  open={buyComputeOpen} setOpen={setBuyComputeOpen} payCountObj={payCountObj} userOtherInfo={userOtherInfo} handleOpenCompute={handleOpen3} />
      {/* 算力消耗 */}
      <ComputeUsageModal open={computeUsageOpen} onCannel={onCancelComputeUsage} payCountObj={payCountObj} />
      <Modal
        className="message-model"
        width={'600px'}
        height={'600px'}
        title={null}
        footer={null}
        open={messageOpen}
        maskClosable={false}
        
        onCancel={() => setMessageOpen(false)}
      >
        <ScrollLazyLoadImage date={'20260107'} pictureExt="jpg" hasFooter={false} total={8} />
      </Modal>
    </>
  );
});

export default Header;
